import css from './index.module.css';

/**
 * custom button component
 * @param {Function} onClick
 * @param {ReactElement} children
 * @param {Boolean} simple determines if the styling of the button is displayed simple or not
 * @param {String} type
 * @param {Boolean} disabled  
 * @returns an custom button
 */
const Button = ({ onClick, children, simple, type, disabled }) => {
    return (
        <button onClick={onClick} className={simple ? css.simple : css.button} type={type ? type : "button"} disabled={disabled}>
            {children}
        </button>
    );
};
export default Button;